module.exports = function(h) {
    if (this.opts.texts.title !== null) {
        return (
            <div class="pull-left VueTables__header-title">
                <h2>{this.opts.texts.title}</h2>
                <small>{this.opts.texts.description}</small>
                <small>{this.opts.texts.detail}</small>
            </div>
        );
    }

    return null;
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/modules/header-title.jsx